import script from "./EditPaw.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPaw.vue?vue&type=script&setup=true&lang=js"

import "./EditPaw.vue?vue&type=style&index=0&id=a8c6b9b6&lang=scss"

const __exports__ = script;

export default __exports__